import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/menus/detailPoint';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const DetailPoint: React.FC<ComponentProps> = ({ menu }) => {
  const classes = useStyles();
  const { point } = menu.fields;

  if (!point) return null;
  return (
    <div className={classes.section}>
      <h4 className={classes.title}>ポイント</h4>
      <p>{point}</p>
    </div>
  );
};

export default DetailPoint;
